import { X } from "lucide-react";
import { Dispatch, SetStateAction, memo } from "react";

interface DialogModalNoTitleProps {
  message: React.ReactElement;
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  expandChart?:
    | "StockAnalysisTable"
    | "SectorAnalysisTable"
    | "HistoricalDataTable";
}

const DialogModalNoTitle = (props: DialogModalNoTitleProps) => {
  const { show, setShow, message, expandChart } = props;

  const handleOnClickNo = () => {
    setShow(false);
  };

  if (!show) return null;

  const renderNoDataMessage =
    !message ||
    (message.props &&
      Object.values(message.props).some(
        (value) => Array.isArray(value) && value.length === 0,
      ));

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center backdrop-blur-md p-4 h-full"
      onClick={() =>
        expandChart === "StockAnalysisTable" ? "" : handleOnClickNo()
      }
    >
      <div
        className={`w-full  max-w-7xl rounded-2xl overflow-hidden z-10 p-6 shadow-2xl z-10 bg-white dark:bg-gray-900/90 relative lg:w-full m-4`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className={`absolute top-3 right-3 text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-white cursor-pointer`}
          onClick={handleOnClickNo}
        >
          <X className="w-5 h-5" />
        </button>

        <div className="text-gray-700 dark:text-white mt-4 w-full h-100">
          {renderNoDataMessage ? (
            <div className="flex items-center justify-center h-full text-center text-gray-500 dark:text-gray-300">
              No data found
            </div>
          ) : (
            message
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(DialogModalNoTitle);
